export const configurationColumnTableFA = {
  activityDate: true /*required field*/,
  done: true /*required field*/,
  type: true /*required field*/,
  fieldNames: true /*required field*/,
  groupNames: false,
  commodity: true,
  productNames: true,
  userNames: true,
  tractorNames: true,
  equipmentNames: true,
  machineActivities: true,
  files: true,
  note: false,
  fromDate: false,
  toDate: false,
  infestationLevel: false,
  interventionReason: false,
  // "treatmentType": false,//NOT USE AT THE MOMENT
  temperature: false,
  humidity: false,
  wind: false,
  rainLast24h: false,
  fieldTags: false,
  subunit: false,
  checks: false,
  phenologicalStage: false,
  title: false,
};

/* QUESTA è LA CONFIGURAZIONE DI DEFAULT PER LE COLONNE NELLA TABELLA ATTVIITA */

/*
export const ColumnTableActivities = {
  "activityDate": true, --> required field
  "done": true, --> required field
  "type": true, --> required field
  "fieldNames": true, --> required field
  "groupNames": true,
  "commodity": true,
  "productNames": true,
  "userNames": true,
  "tractorNames": true,
  "equipmentNames": true,
  "machineActivities": true,
  "shapeFileTotal": true,
  "files": true,
  "fromDate": false,
  "toDate": false,
  "infestationLevel": false,
  "interventionReason": false,
  //"treatmentType": false,//NOT USE AT THE MOMENT
  "temperature": false,
  "humidity": false,
  "wind": false,
  "rainLast24h": false,
  "fieldTags": false,
  "subunit": false
}
*/
